import { elementScrollIntoView } from "seamless-scroll-polyfill";

const characteristicsBlock = document.querySelector(".js-characteristics-collapse-init");
const characteristicsBtn = document.querySelector(".js-more-characteristics-link");

function characteristicsBlockHidden() {
    if (characteristicsBlock) {
        characteristicsBlock.classList.add("collapsed");

        if (characteristicsBtn) {
            characteristicsBtn.textContent = "Показать ещё параметры";

            characteristicsBtn.addEventListener("click", (e) => {
                e.preventDefault();

                if (characteristicsBlock.classList.contains("collapsed")) {
                    characteristicsBlock.classList.remove("collapsed");
                    characteristicsBtn.textContent = "Скрыть дополнительные параметры";
                    characteristicsBtn.classList.add("active");
                } else {
                    characteristicsBlock.classList.add("collapsed");
                    characteristicsBtn.textContent = "Показать ещё параметры";
                    characteristicsBtn.classList.remove("active");
                    elementScrollIntoView(characteristicsBlock, {
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        }
    }
}

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        characteristicsBlockHidden();
    }
});
